import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
import { resolveVerifiedDocument } from "../api/client";
import { useAuth } from "../auth/OAuthContext";
import { BrandLogo } from "../components/BrandLogo";

export function VerifiedDocumentRedirect() {
  const { sealToken } = useParams<{ sealToken: string }>();
  const { idToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sealToken || !idToken) return;

    resolveVerifiedDocument(idToken, sealToken)
      .then(({ documentId }) => navigate(`/documents/${documentId}`, { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, [idToken, navigate, sealToken]);

  if (!sealToken) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm flex flex-col items-center text-center max-w-sm w-full gap-4">
        <BrandLogo className="h-10 w-auto" />
        <div className="w-8 h-8 border-3 border-indigo-100 border-t-[#012699] rounded-full animate-spin my-2" aria-hidden="true" />
        <p className="text-sm font-medium text-slate-500">{error ?? "Checking document access..."}</p>
      </div>
    </main>
  );
}
